/**
 * AssetsSearchPage - Full page POI/Asset search view
 *
 * Uses the UnifiedPOITable component with variant="fullPage"
 * State is shared via POITableContext across all table instances
 */

import React, { useEffect, useState } from 'react';
import UnifiedPOITable from './UnifiedPOITable';
import { POI } from '../types';

interface AssetsSearchPageProps {
  assetId?: string;
  onViewTickets?: (poi: any) => void;
  onCreateTicket?: (poi: any) => void;
  onNavigateToViewer?: (poi: POI) => void;
  onHighlightGroup?: (pois: POI[], color?: string) => void;
  loadedIfcFiles?: string[];
  loadingIfcFiles?: string[];
  onRequestLoadModel?: (fileName: string) => void;
  viewerSelectedDbIds?: Array<number | { dbId: number; elementId?: number | null; externalId?: string | null; name?: string | null; ifcGuid?: string | null }>;
}

const AssetsSearchPage: React.FC<AssetsSearchPageProps> = ({
  assetId, onViewTickets, onCreateTicket,
  onNavigateToViewer,
  onHighlightGroup,
  loadedIfcFiles = [],
  loadingIfcFiles = [],
  onRequestLoadModel,
  viewerSelectedDbIds = [],
}) => {
  // Resolve asset ID from props or sessionStorage
  const [resolvedAssetId, setResolvedAssetId] = useState<string | null>(null);

  useEffect(() => {
    let currentAssetId = assetId;
    if (!currentAssetId) {
      const storedAssetId = sessionStorage.getItem('mabat3d_selectedAssetId');
      if (storedAssetId) currentAssetId = storedAssetId;
    }
    setResolvedAssetId(currentAssetId || null);
  }, [assetId]);

  if (!resolvedAssetId) {
    return (
      <div className="dt-body">
        <div className="dt-statebox">
          No site selected
          <div style={{ marginTop: 6 }}>Please select a site from the Sites page first.</div>
        </div>
      </div>
    );
  }

  return (
    <UnifiedPOITable
      variant="fullPage"
      onViewTickets={onViewTickets}
      onCreateTicket={onCreateTicket}
      siteId={resolvedAssetId}
      onNavigateTo3D={onNavigateToViewer}
      onHighlightGroup={onHighlightGroup}
      loadedModels={loadedIfcFiles}
      loadingModels={loadingIfcFiles}
      onRequestLoadModel={onRequestLoadModel}
      showEditMode={true}
      showBulkActions={true}
      showColumnSelector={true}
      showDeleteAll={true}
      viewerSelectedDbIds={viewerSelectedDbIds}
    />
  );
};

export default AssetsSearchPage;
